import { get, post } from '@/api/request'

export default {

  store: (project, success, failure) => post(
    '/api/project',
    project,
    success, failure
  ),

  storeRequest: (project, success, failure) => post(
    '/api/project-request',
    project,
    success, failure
  ),

  save: (project, success, failure) => post(
    `/api/project/${project.id}`,
    project,
    success, failure
  ),

  loadProject: (projectId, success, failure) => get(
    `/api/projects/${projectId}/payload`,
    success, failure
  ),

  close: (projectId, success, failure) => post(
    `/api/project/${projectId}/close`,
    {},
    success, failure
  ),

  open: (projectId, success, failure) => post(
    `/api/project/${projectId}/open`,
    {},
    success, failure
  ),
  
  complete: (projectId, success, failure) => post(
    `/api/project/${projectId}/complete`,
    {},
    success, failure
  ),
  
  deleteProject: (projectId, success, failure) => post(
    `/api/project/${projectId}/delete`,
    {},
    success, failure
  ),

  addCollaborator: ({ project, company }, success, failure) => post(
    `/api/project/${project}/collaborators/${company}`,
    {},
    success, failure
  ),

  removeCollaborator: ({ project, company }, success, failure) => post(
    `/api/project/${project}/collaborators/${company}/remove`,
    {},
    success, failure
  ),

  storeMilestone: (payload, success, failure) => post(
    `/api/project/${payload.project}/milestone`,
    payload,
    success, failure
  ),
  
  deleteMilestone: (milestoneId, success, failure) => post(
    `/api/milestone/${milestoneId}/delete`,
    {}, success, failure
  ),

  sortMilestones: (payload, success, failure) => post(
    `/api/project/${payload.project}/milestones/sort`,
    payload, success, failure
  ),

  updateMilestoneTitle: (payload, success, failure) => post(
    `/api/milestone/${payload.milestoneId}/title`,
    payload,
    success, failure
  ),
  
  updateMilestoneDueDate: (payload, success, failure) => post(
    `/api/milestone/${payload.milestoneId}/due-date`,
    payload,
    success, failure
  ),
  
  markMilestoneComplete: (payload, success, failure) => post(
    `/api/milestone/${payload}/complete`,
    {},
    success, failure
  ),
  
  reopenMilestone: (payload, success, failure) => post(
    `/api/milestone/${payload}/reopen`,
    {},
    success, failure
  ),
  
  startReview: (projectId, success, failure) => post(
    `/api/project/${projectId}/review`,
    {},
    success, failure
  ),

  acceptRequest: (projectId, success, failure) => post(
    `/api/project/${projectId}/accept-request`,
    {},
    success, failure
  ),
  
  declineRequest: (payload, success, failure) => post(
    `/api/project/${payload.projectId}/decline-request`,
    payload,
    success, failure
  ),
  
  submitBriefAmendment: (payload, success, failure) => post(
    `/api/project/${payload.projectId}/brief-amendment`,
    payload,
    success, failure
  ),

}
